module.exports = __webpack_public_path__ + "img/szkjsw.7a093151.jpg";